// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3f6rR","additionalInfo":"AgreementModal_additionalInfo__ewwtz"};